import "~/misc/common";
import { p } from "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { Chart } from "chart.js";
import { doughnutChartOptions, lineChartOptions, zoomOptions } from "~/misc/charts";
import moment from "moment";

export default class extends Controller {
  connect() {
    p('initDailyLimitsChart');

    $('.datetimepicker').datetimepicker().on('dp.change', function (ev) {
      $('form.new_q').trigger('submit');
    });

    const datasets = $('#toJs').data('datasets');
    p(datasets);
    const zoom = $('#toJs').data('zoom');
    p(zoom);
    const doughnut = $('#toJs').data('doughnut');
    p(doughnut);

    if ($('#chart')[0]) {

      const ctx = $('#chart')[0] as HTMLCanvasElement;
      const options = Object.assign({}, lineChartOptions) as any;
      options.scales = {
        x: {
          type: 'time',
          time: {
            unit: 'day',
            tooltipFormat: 'YYYY.MM.DD',
            displayFormats: {
              minute: 'HH:mm',
              hour: 'HH:mm',
              day: 'YYYY.MM.DD'
            }
          },
          min: zoom.min,
          max: zoom.max,
          stacked: true
        },
        y: {
          beginAtZero: true,
          stacked: true
        }
      };
      options.plugins.tooltip = {
        callbacks: {
          title: function (tooltipItems: any) {
            return moment(tooltipItems[0].parsed.x).format('YYYY.MM.DD');
          },
          label: function (tooltipItem: any) {
            return tooltipItem.dataset.label + ': ' + tooltipItem.parsed.y + ' fő';
          }
        }
      };
      options.plugins.zoom = Object.assign({}, zoomOptions) as any;
      options.plugins.zoom.pan.mode = 'x';
      options.plugins.zoom.zoom.mode = 'x';
      new Chart(ctx, {
        type: 'scatter',
        data: {
          datasets: datasets
        },
        options: options
      });
    }

    if ($('#doughnut')[0]) {
      const ctx = $('#doughnut')[0] as HTMLCanvasElement;
      const options = Object.assign({}, doughnutChartOptions) as any;
      options.plugins.tooltip = {
        callbacks: {
          label: function (tooltipItem: any) {
            const total = tooltipItem.chart._metasets[tooltipItem.datasetIndex].total;
            const percent = (tooltipItem.parsed / total * 100).toFixed(1);
            return tooltipItem.label + ': ' + tooltipItem.parsed + ' nap (' + percent + '%)';
          }
        }
      };
      new Chart(ctx, {
        type: 'doughnut',
        data: {
          datasets: doughnut.datasets,
          labels: doughnut.labels
        },
        options: options
      });
    }
  }
}
